import { apiAxios } from '../axios'

let baseURL = 'http://eu.rakumart.cn/index.php?mod=inc&act=ordersys&'
let token = localStorage.getItem('token')
export default {
    
    
}